import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.mjs";

import type { PDFDocumentProxy } from "pdfjs-dist/legacy/build/pdf.mjs";

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/legacy/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

export const loadFile = async (file: ArrayBuffer) => {
  try {
    const pdfDoc = await pdfjsLib.getDocument({
      data: file,
      useWorkerFetch: true,
      isEvalSupported: true,
      useSystemFonts: true,
    }).promise;

    return pdfDoc;
  } catch (error) {
    console.error("Erro ao carregar arquivo: ", error);
    if (error instanceof Error) {
      throw new Error(`Erro ao carregar arquivo: ${error.message}`);
    }
    throw new Error("Erro ao carregar arquivo");
  }
};

export const extractTextFromPdf = async (
  pdf: PDFDocumentProxy,
  limitPages: number,
  onProgress: (progress: number) => void
): Promise<string> => {
  try {
    const maxPages = Math.min(pdf.numPages, limitPages); // Limit to first 25 pages
    const textParts: string[] = [];

    onProgress(0);

    for (let pageNumber = 1; pageNumber <= maxPages; pageNumber++) {
      const page = await pdf.getPage(pageNumber);
      const textContent = await page.getTextContent();

      // Extract text items and join them
      const pageText = textContent.items
        .map((item: any) => item.str)
        .filter(Boolean)
        .join(" ")
        .replace(/\s+/g, " ")
        .trim();

      if (pageText) {
        textParts.push(pageText);
      }

      // Update progress
      const progress = Math.round((pageNumber / maxPages) * 100);
      onProgress(progress);
    }

    const fullText = textParts.join(" ").trim();

    if (!fullText) {
      throw new Error("Não foi possível extrair texto do PDF");
    }

    return fullText;
  } catch (error) {
    console.error("Erro ao extrair texto do PDF: ", error);
    throw new Error("Erro ao extrair texto do PDF");
  }
};

export const convertToImage = async (
  pdf: PDFDocumentProxy
): Promise<string[]> => {
  try {
    const images: string[] = [];
    const scale = 1.5;

    for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
      const page = await pdf.getPage(pageNumber);
      const viewport = page.getViewport({ scale });

      // Create canvas in memory
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d", { alpha: false });
      if (!context) throw new Error("Cannot get canvas context");

      // Set canvas dimensions
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Render PDF page to canvas
      const renderContext = {
        canvasContext: context,
        viewport: viewport,
        enableWebGL: true,
      };

      await page.render(renderContext).promise;

      // Convert canvas to image data URL
      images.push(canvas.toDataURL("image/jpeg", 0.95));
    }

    return images;
  } catch (error) {
    console.error("Erro ao analisar imagem: ", error);
    throw new Error("Erro ao analisar imagem");
  }
};
